import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './console.css';
import { App } from './App.js';
import { LocaleProvider } from './i18n/index.js';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </StrictMode>,
);
